import { useTenantTranslation } from "hooks/formatters";
import { useNumberSerialiser } from "hooks/serialisers/numbers";

export interface FormattedNameProps {
  multipleMixes: boolean;
  chemistryGroupName: string;
  mix: number;
}

export const useFormattedName = ({
  multipleMixes,
  chemistryGroupName,
  mix,
}: FormattedNameProps) => {
  const { t } = useTenantTranslation();
  const { format } = useNumberSerialiser();
  const formattedName =
    chemistryGroupName + (multipleMixes ? ` (${t("mix")} ${format(mix)})` : "");
  return formattedName;
};
